import React from 'react';
import { Switch } from 'react-router-dom';

import Route from './Route';

import Login from '../pages/Login';
import RegisterCompany from '../pages/RegisterUser';
import RegisterProject from '../pages/RegisterProject';
import Page404 from '../pages/Page404';

const Routes: React.FC = () => (
  <Switch>
    <Route path="/" exact component={Login} />
    <Route path="/register-user" component={RegisterCompany} isPrivate />
    <Route path="/register-project" component={RegisterProject} isPrivate />

    <Route component={Page404} />
  </Switch>
);

export default Routes;
